import React from 'react'

function Option({ icon, image, title, ...otherProps }) {
    return (
        <button { ...otherProps } className="outline-none flex flex-col items-center gap-2">
            <div className="flex items-center justify-center">
                <>
                    {
                        image?.length ? 
                        <div className="size-6 rounded border border-[#808080] overflow-hidden">
                            <img src={image} alt="" />
                        </div> :
                        <img src={icon} alt="" />
                    }
                </>
            </div>

            <h1 className='text-[#121212] font-normal text-[12px] leading-[14px]'>{title}</h1>
        </button>
    )
}

export default Option;
